import router from "@/router";
import { store } from "@/store";
import KeycloakService from "./keycloak/keycloakService";
import { UserRest } from "./rest/user.rest";


export default class LoginService {
    constructor( private _login = new UserRest()){}

    getUserInfo(){
        return this._login.getUserInfo().then((response) => {
            store.dispatch('users/setUserInfo', response)
            localStorage.setItem('userInfo', JSON.stringify(response));

            const mainRole = response?.roles[0];

            if(mainRole.includes('ADMIN_IOSI')){
                router.push({ name: "Organizations" })
            } else if(mainRole.includes('ADMIN')){
                router.push({ name: "Users" })
            } else {
                router.push({ name: "ScheduleClient" })
            }
        });
    }
}